@import '../../../globals/variables';

/**
 * THEME JSON CONFIG CSS VARS
 * The following default component scss variables can be overwritten via theme configuration per brand.
 * If you need to add new one, please make sure to set a default value.
 * JSON Definition for Component with name "Example": testCssVar: "20px"
 * Resulting CSS var: $example-test-css-var: 20px;
 */

$file-preview-box-radius: 4px !default;
$file-preview-image-radius: 4px 0 0 4px !default;
$file-preview-preview-margin-left: 0 !default;

/* END THEME JSON CONFIG CSS VARS ******************************************************* */

:host {
  display: block;
}

* {
  box-sizing: border-box;
}

.#{$prefix}fileupload {
  &__preview {
    display: flex;
    flex-direction: column;

    &__box {
      background: v(boxBackground);
      display: flex;
      align-items: center;
      width: 100%;
      min-height: 90px;
      border-radius: $file-preview-box-radius;
    }

    &__image {
      width: 80px;
      flex-shrink: 0;
      margin-right: 16px;
      display: flex;
      align-self: stretch;
      border-top-left-radius: 4px;
      border-bottom-left-radius: 4px;
      overflow: hidden;
      pointer-events: none;
      user-select: none;
      position: relative;
      margin-left: $file-preview-preview-margin-left;
      border-radius: $file-preview-image-radius;
    }

    &__file-icon {
      height: 80px;
      width: 80px;
      margin-right: 16px;
      margin-left: $file-preview-preview-margin-left;
      display: flex;
      justify-content: center;

      envc-eon-ui-icon {
        color: v(fileIconColor);
      }
    }

    &__description {
      display: flex;
      flex: 1;
      flex-direction: column;
      justify-self: center;
      overflow-wrap: break-word;
      word-break: break-word;
      padding: 20px 0px 16px 0px;

      &__size {
        color: v(descriptionColor);
      }

      &__name {
        color: v(textColor);
      }
    }

    &__icon-wrapper {
      display: flex;
      justify-content: center;
      min-width: 80px;
    }

    &__icon {
      cursor: pointer;
      color: v(iconColor) !important;
      flex-shrink: 0;

      &:focus {
        outline: none;
      }

      &:focus-visible {
        outline-style: solid;
        outline-width: 3px;
        outline-color: $eon-system-highlight;
        outline-offset: 3px;
        border-radius: 50%;
      }

      &:hover {
        outline-style: solid;
        outline-width: 2px;
        outline-offset: 4px;
        outline-color: v(previewCancelIconColor);
        border-radius: 50%;
      }

      &--cancel {
        display: flex;
        justify-content: center;
        width: 32px;

        envc-eon-ui-icon {
          --color: var(--previewCancelIconColor);
        }

        &:focus-visible {
          outline-style: solid;
          outline-width: 2px;
          outline-offset: 2px;
          outline-color: v(previewCancelIconOutline);
          border-radius: 50%;
        }

        &:hover {
          outline-style: solid;
          outline-width: 2px;
          outline-offset: 2px;
          outline-color: v(previewCancelIconColor);
          border-radius: 50%;

          envc-eon-ui-icon {
            --color: var(--previewCancelIconHoverColor);
          }
        }
      }
    }
  }
}
